import cx from 'classnames';
import store from '~/javascripts/store.js';

export default ({ value, highlighted }) => {
  const handleClick = () => {
    store.donateForm.amount = value;
    store.donateForm.showOtherAmountInput = false;
    store.donateForm.isWpsAmountButtonSelected = false;
  };

  const { amountButtonSubscriptionPeriod, currencyUnit } = store.donateForm;

  return (
    <a
      className={cx('button button--grey-20 amount-button', {
        selected: highlighted,
      })}
      key={value}
      onClick={handleClick}
    >
      {currencyUnit}
      {value}
      <span className='amount-buttons'>
        <>
          &nbsp;
          <span className='uppercase'>{store.donateForm.currencyName}</span>
          {amountButtonSubscriptionPeriod}
        </>
      </span>
    </a>
  );
};
